import { variantFragment } from '@containers/ProductDetailContainer/queries/__generated__/variantFragment';

export const isPriceSame = (variants: variantFragment[]): boolean =>
  variants.every(
    (variant, _, array) => variant.price.value === array[0].price.value
  );
